import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { QueryStats } from '@mui/icons-material';

const NAVY = '#0D1B35';
const BLUE = '#0066CC';

export const ReportsComingSoon: React.FC = () => {
  return (
    <Box>
      {/* Hero */}
      <Box
        sx={{
          borderRadius: 4,
          bgcolor: NAVY,
          backgroundImage:
            'radial-gradient(rgba(255,255,255,0.045) 1px, transparent 1px), radial-gradient(circle at 80% -10%, rgba(0,102,204,0.22), transparent 55%)',
          backgroundSize: '22px 22px, 100% 100%',
          p: { xs: '28px 24px', sm: '44px 48px' },
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 260,
            height: 260,
            borderRadius: '50%',
            bgcolor: 'rgba(0,102,204,0.10)',
            top: -80,
            right: -60,
            pointerEvents: 'none',
          }}
        />
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.55)',
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            mb: 1.25,
          }}
        >
          Reportes
        </Typography>
        <Typography variant="h2" sx={{ color: '#fff' }}>
          Análisis e insights
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: { xs: 13, sm: 14 }, mt: 0.75 }}>
          Métricas de uso, desempeño y operación de la plataforma.
        </Typography>
      </Box>

      {/* Coming-soon card */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          p: { xs: 5, sm: 8 },
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* decorative ring */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 420,
            height: 420,
            borderRadius: '50%',
            border: '1px solid rgba(0,102,204,0.06)',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 260,
            height: 260,
            borderRadius: '50%',
            border: '1px solid rgba(0,102,204,0.08)',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
          }}
        />

        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            mx: 'auto',
            mb: 3,
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'rgba(0,102,204,0.08)',
            color: BLUE,
            position: 'relative',
          }}
        >
          <QueryStats sx={{ fontSize: 34 }} />
        </Box>

        <Typography
          sx={{
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: BLUE,
            mb: 1,
            position: 'relative',
          }}
        >
          Próximamente
        </Typography>
        <Typography variant="h3" sx={{ color: NAVY, mb: 1.5, position: 'relative' }}>
          Estamos rediseñando los reportes
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: 14,
            maxWidth: 480,
            mx: 'auto',
            lineHeight: 1.6,
            position: 'relative',
          }}
        >
          La sección de análisis está en desarrollo para ofrecerte métricas más útiles
          y enfocadas en la operación actual de la plataforma. Vuelve pronto para ver
          la nueva versión.
        </Typography>
      </Paper>
    </Box>
  );
};
